var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import { AXSBlock } from '@axs/axsui-axsblock';
import { AXSFlex } from '@axs/axsui-axsflex';
import classnames from 'classnames';
import { parseThemePath } from '@axs/axsui-theme';
import { AXSIconClose } from '@axs/axsui-icons';
var Notification = styled(AXSFlex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-sizing: border-box;\n  background-color: ", ";\n  min-height: 60px;\n  padding-right: ", ";\n  position: relative;\n  width: 100%;\n"], ["\n  box-sizing: border-box;\n  background-color: ", ";\n  min-height: 60px;\n  padding-right: ", ";\n  position: relative;\n  width: 100%;\n"])), function (_a) {
    var theme = _a.theme, type = _a.type;
    return parseThemePath("axsui.status.".concat(type, ".default"), theme, '#007def');
}, function (_a) {
    var button = _a.button;
    return (button ? '10px' : '50px');
});
var Content = styled(AXSBlock)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  box-sizing: border-box;\n  color: #ffffff;\n  order: -1;\n  width: 100%;\n"], ["\n  box-sizing: border-box;\n  color: #ffffff;\n  order: -1;\n  width: 100%;\n"])));
var Dismiss = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: block;\n  position: absolute;\n  right: 10px;\n  top: 15px;\n"], ["\n  display: block;\n  position: absolute;\n  right: 10px;\n  top: 15px;\n"])));
var Button = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""])));
var AXSNotification = function (_a) {
    var borderRadius = _a.borderRadius, button = _a.button, children = _a.children, className = _a.className, onClose = _a.onClose, showMore = _a.showMore, type = _a.type, props = __rest(_a, ["borderRadius", "button", "children", "className", "onClose", "showMore", "type"]);
    var classes = ['c-axs-notification', { 'c-axs-notification--active': showMore }, className];
    return (React.createElement(Notification, { className: classnames(classes), alignItems: "center", type: type, borderRadius: borderRadius, padded: true },
        button ? (React.createElement(Button, null, button)) : (React.createElement(Dismiss, { className: "c-axs-event-banner__expander", onClick: onClose },
            React.createElement(AXSIconClose, { size: "30px", color: "#ffffff", style: { cursor: 'pointer' } }))),
        React.createElement(Content, __assign({ className: "c-axs-notification__content" }, props), children)));
};
AXSNotification.defaultProps = {
    type: 'info',
};
/** @component */
export { AXSNotification };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
